
import {
  Mixins,
  Component,
  Watch,
  Prop,
} from 'vue-property-decorator';
import BsMixin from '@/views/Home/mixins/bsMixin';
import noData from '@/components/noData/index.vue';
import {
  Card,
  Col,
  Button,
  Row,
  Tag,
} from 'element-ui';
import api from '@/api/sensitive';
import pageMixin from '../../../../mixins/pageMixin';


  @Component({
    components: {
      Card,
      Col,
      Button,
      Row,
      Tag,
      noData,
    },
  })

export default class bData extends Mixins(pageMixin, BsMixin) {
  @Prop({
    default: false,
  })sensitiveList!: any;

  public $refs!:{
    list: Element,
    wrapper: Element
  }

  private tagType: any = [
    { type: '' },
    { type: 'info' },
    { type: 'success' },
  ]

  mounted() {
    this.initBS(this.$refs.list);
  }

  handleClose(id: string) {
    this.confirm('你确定要删除该敏感词吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.delSensitive(id).then((res: any) => {
        this.$emit('delFinish');
      });
      close();
      this.$log({
        title: '正式课管理 - 删除 - 确定',
        component: 'trial/manage/bModal',
      });
    }).catch(() => this.$log({
      title: '正式课管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }
}
